import type { IServicesCollection } from 'src/packages/di';

import { SoundAlarmService } from './SoundAlarmService';

declare module 'src/packages/di' {
  export interface ServicesCollectionMap {
    soundAlert: SoundAlarmService;
  }
}

export function addSoundAlarmService(di: IServicesCollection) {
  const soundService = di.requireService('soundService');
  const soundAlarm = new SoundAlarmService(soundService);

  di.addSingleton('soundAlert', soundAlarm);
}
